import { render, staticRenderFns } from "./updateinfo.vue?vue&type=template&id=7a5fd1c5"
import script from "./updateinfo.vue?vue&type=script&lang=js"
export * from "./updateinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppStoreLinks: require('/vercel/path0/components/blocks/AppStoreLinks.vue').default})
